import React, { useState, useEffect } from "react";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, IconButton } from "@mui/material";
import { HeaderConfig, StockDetailsHeaderConfig } from "./config";
import StockDetailsFilters from "./stock-details-filters";
import CustomButtonComponent from "../../../core/custom-button";
import CustomTable from "../../../core/custom-table";
import SiFileUpload from "../../../core/file-uploader";
import { PAGE_LIMIT } from "../../../utils";
// import ClaimsFilters from "../../oem/claims/claims-filters";

const StockDetails = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sortBy: "-createdAt",
  });

  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STOCK_DETAILS}`,
      null,
      { download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `SAP Float Engines.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STOCK_DETAILS}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Float Engine Movements</p>
          <p className="section-name">SAP Float Engines</p>
        </div>
      </div>
      <div>
        <div className="create-con">
          <p className="primary-text">SAP Float Engines Index</p>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            <SiFileUpload
              fileTypes={[
                ".csv",
                ".xls",
                ".xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
              ]}
              title="Upload Float Engines"
              url={`${HOSTNAME}${REST_URLS.STOCK_DETAILS}/bulk-upload`}
              callBack={() => {
                loadData({
                  page: 1,
                  sortBy: "-createdAt",
                  limit: PAGE_LIMIT,
                });
              }}
            />
            <CustomButtonComponent
              variant="contained"
              color="success"
              onClick={downloadReports}
            >
              Download
            </CustomButtonComponent>
          </Box>
        </div>
        <div className="si-hide-mobile">
          <CustomTable
            header={StockDetailsHeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<StockDetailsFilters loadData={loadData} filter={filters} />}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
export default StockDetails;
